/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCompostIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-compost"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 23.13Q9.75 23.13 7.75 22.26Q5.75 21.4 4.28 19.93Q2.8 18.45 1.94 16.45Q1.07 14.45 1.07 12.2Q1.07 9.95 1.94 7.95Q2.8 5.95 4.28 4.47Q5.75 3 7.75 2.14Q9.75 1.27 12 1.27L12 0Q12 -0.45 12.4 -0.63Q12.8 -0.8 13.13 -0.47L15.68 2.08Q16.07 2.48 16.07 3Q16.07 3.52 15.68 3.92L13.13 6.47Q12.8 6.8 12.4 6.63Q12 6.45 12 6L12 4.72Q8.9 4.72 6.71 6.91Q4.53 9.1 4.53 12.2Q4.53 14.1 5.4 15.71Q6.28 17.32 7.75 18.35Q8.2 17.55 9.11 16.99Q10.03 16.43 11.2 16.27Q11.1 15.68 10.96 15.07Q10.82 14.47 10.63 13.95Q10.32 14.22 9.94 14.36Q9.55 14.5 9.13 14.5Q8.18 14.5 7.5 13.82Q6.83 13.15 6.83 12.2L6.83 11.05Q6.83 10.82 6.79 10.61Q6.75 10.4 6.7 10.2Q6.55 9.9 6.71 9.63Q6.88 9.35 7.22 9.38Q8.5 9.43 9.95 10.01Q11.4 10.6 11.43 12.2Q11.43 12.45 11.39 12.68Q11.35 12.9 11.22 13.13Q10.85 12.85 10.49 12.61Q10.13 12.38 9.7 12.2Q10.2 12.57 10.82 13.35Q11.45 14.13 12 15.2Q12.57 13.78 13.44 12.41Q14.3 11.05 15.45 9.9Q14.8 10.35 14.19 10.88Q13.57 11.4 13 11.97Q12.8 11.65 12.69 11.28Q12.57 10.9 12.57 10.47Q12.57 9.28 13.41 8.44Q14.25 7.6 15.45 7.6L16.6 7.6Q17 7.6 17.45 7.5Q17.9 7.4 18.2 7.13Q18.4 6.92 18.65 7.04Q18.9 7.15 18.93 7.42Q18.93 8.13 18.82 9.15Q18.73 10.18 18.36 11.1Q18 12.03 17.31 12.69Q16.63 13.35 15.45 13.35Q15.03 13.35 14.64 13.24Q14.25 13.13 13.93 12.93Q13.72 13.47 13.47 14.36Q13.22 15.25 13.07 16.3Q14.15 16.5 14.99 17.05Q15.82 17.6 16.25 18.35Q17.45 17.52 18.26 16.29Q19.07 15.05 19.35 13.55Q19.48 12.82 19.99 12.34Q20.5 11.85 21.2 11.85Q21.93 11.85 22.43 12.38Q22.93 12.9 22.82 13.63Q22.3 17.65 19.25 20.39Q16.2 23.13 12 23.13Z" fill={color} />
    </svg>
  );
}
